<nav class="nav fixed-top p-3 justify-content-center"
style="background-image: url('assets/img/h1_hero.png');
              background-repeat: no-repeat;
                background-attachment: fixed;
      background-position: center; 
       background-size: cover;
            "
            >
    <a class="nav-link" routerLink="/">Home</a>
    <a class="nav-link" routerLink="/aplikasi">Applikasi</a>
    <a class="nav-link" routerLink="/website">Website</a>
    <a class="nav-link" routerLink="/axcoraschool">ERP</a>
  </nav>
    <div class="slider-area "
        style="background-image: url('assets/img/h1_hero.png');
              background-repeat: no-repeat;
                background-attachment: fixed;
      background-position: center; 
       background-size: cover;
            "
            >
    <div class="container">
    <div class="row justify-content-center">
        <div class="col-12 col-md-6 p-3 p-md-5">
            <div class="p-3 p-md-5">
    <h1 data-animation="bounceIn" data-delay="0.2s" class="text-white">Axcora School ERP</h1>
    <p class="text-white" data-animation="fadeInUp" data-delay="0.4s"><strong><a href="https://axcoraschool.vercel.app">aplikasi sekolah terbaru terlengkap modern </a></strong>
        untuk dunia pendidikan dan edukasi, sahabat para guru dan siswa.
        </p>
        <p class="text-white">
            All in one aplikasi belajar mengajar e-learning online, absensi kesiswaan, rapot ujian dan nilai online, pengumuman agenda sekolah, upload dan download file tugas , mata pelajaran, jadwal pelajaran, dan keuangan sekolah all in one handling by axcora school apps ini.
        </p>
    </div>
</div>
    <div class="col-12 col-md-6 p-3 p-md-5">
        <div class="p-3 p-md-5 text-center">
        <img class="img-fluid" src="assets/img/axcora school apps aplikasi sekolah online lengkap pembukuan ujian online.png" alt="aplikasi sekolah ERP Axcora school"/>
    </div></div>
    <div class="col-3 col-md-3 p-3 p-md-5">
        <div class="p-3 p-md-5 text-center">
<img class="img-fluid" alt="aplikasi admin sekolah" 
src="assets/img/absensisekolah.png"/>
<p class="text-light">Admin Apps</p>
            </div>
    </div>
    <div class="col-3 col-md-3 p-3 p-md-5">
        <div class="p-3 p-md-5 text-center">
<img class="img-fluid" alt="aplikasi guru" 
src="assets/img/rapot.png"/>
<p class="text-light">Guru Apps</p>
            </div>
    </div>
    <div class="col-3 col-md-3 p-3 p-md-5">
        <div class="p-3 p-md-5 text-center">
<img class="img-fluid" alt="aplikasi keuangan sekolah" 
src="assets/img/pembayaransekolah.png"/>
<p class="text-light">Tata Usaha</p>
            </div>
    </div>
    <div class="col-3 col-md-3 p-3 p-md-5">
        <div class="p-3 p-md-5 text-center">
<img class="img-fluid" alt="aplikasi siswa murid" 
src="assets/img/elearns.png"/>
<p class="text-light">Siswa Apps</p>
            </div>
    </div>
    <div class="col-12 col-md-12 p-3 p-md-5 text-center">
        <img class="img-fluid" src="assets/img/aplikasisekolaherpaxcoraschool.png" alt="aplikasi sekolah ERP Axcora school"/>
        <div class="p-3 p-md-5 text-center">
<p class="text-white">All in one dalam satu applikasi berbagai kebutuhan , saat nya revolusi digital sekolah anda bersama axcora school apps.</p>
            </div>
    </div>
    </div>
    </div>
    </div>
    
 
    
    <div id="start" class="our-services">
    <div class="container">
    <div class="row justify-content-center">
    <div class="col-xl-7 col-lg-8">
    
    <div class="section-tittle text-center mb-80">
        <img class="img-fluid rounded shadow" src="assets/img/aplikasisekolahonline.png" alt="aplikasi sekolah ERP Axcora school"/>        
    <p>Temukan beragam kemudahan bersama axcora school apps technology all in one applikasi untuk berbagai kebutuhan , ERP management yang lengkap memudahkan dalam kontrol pembukuan sekaligus proses belajar mengajar.</p>
    </div>
    </div>
    </div>
    <div class="row text-center">
        <div class=" col-6 col-md-4">
    <div class="single-services mb-30">
    <div class="services-ion">
    <img src="assets/img/websekolah.png" alt="pembuatan website sekolah"/>
    </div>
    <div class="services-cap">
    <h5>Website</h5>
    <p>Website include dengan domain sekolah .sch .id.</p>
    </div>
    </div>
    </div>
    <div class=" col-6 col-md-4">
    <div class="single-services mb-30">
    <div class="services-ion">
    <img src="assets/img/absensisekolah.png" alt="aplikasi sekolah absensi"/>
    </div>
    <div class="services-cap">
    <h5>Absensi</h5>
    <p>Ready Absensi dalam kebutuhan monitoring kinerja siswa.</p>
    </div>
    </div>
    </div>
    <div class=" col-6 col-md-4">
    <div class="single-services mb-30">
    <div class="services-ion">
    <img src="assets/img/media.png" alt="aplikasi belajar online download upload media"/>
    </div>
    <div class="services-cap">
    <h5>Media</h5>
    <p>Proses upload dan download tugas sekolah semakin mudah dan cepat.</p>
    </div>
    </div>
    </div>
    <div class=" col-6 col-md-4">
    <div class="single-services mb-30">
    <div class="services-ion">
    <img src="assets/img/tugas.png" alt="aplikasi belajar sekolah"/>
    </div>
    <div class="services-cap">
    <h5>Pelajaran</h5>
    <p>Mudah dalam membuat jadwal daftar mata pelajaran dan ujian online.</p>
    </div>
    </div>
    </div>
    <div class=" col-6 col-md-4">
    <div class="single-services mb-30">
    <div class="services-ion">
    <img src="assets/img/rapot.png" alt="aplikasi rapot dan penilaian online"/>
    </div>
    <div class="services-cap">
    <h5>Nilai</h5>
    <p>Semakin memudahkan untuk penilaian tugas ujian hingga rapot siswa murid.</p>
    </div>
    </div>
    </div>
    <div class=" col-6 col-md-4">
    <div class="single-services mb-30">
    <div class="services-ion">
    <img src="assets/img/pembayaransekolah.png" alt="aplikasi pembayaran uang sekolah dan keuangan sekolah"/>
    </div>
    <div class="services-cap">
    <h5>Keuangan Apps</h5>
    <p>Monitoring keuangan dan transaksi invoice pembayaran tersedia.</p>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
    
    
    <div class="about-area2 section-padding40 section-bg2" data-background="assets/img/section-bg3.png">
    <div id="aplikasi" class="container">
    <div class="row align-items-center">
    <div class="col-xl-5 col-lg-6 col-md-12">
    <div class="about-caption mb-50">
    <div class="section-tittle mb-25">
    <h2>Admin Apps.</h2>
    </div>
    <p class="mb-20">
Admin apps dengan kuasa penuh untuk berbagai kebutuhan mulai dari proses pembuatan database kelas, ruangan , kurikulum , guru dan staff , orang tua wali murid, siswa dan penerimaan siswa baru . dan kebutuhan untuk e learn ,office keuangan dan setting pengumuman agenda sekolah.
    </p>
    <a href="https://youtu.be/t24CXOYOVOU" target="_blank" class="btn all-btn text-white">Informasi</a>
    </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-9 col-sm-9">
    
    <div class="about-img ">
    <img class="img-fluid shadow rounded" src="assets/img/aplikasi sekolah online e-learn website sekolah (5).png" alt="aplikasi sekolah terlengkap"/>
    </div>
    </div>
    </div>
    </div>
    </div>
    
    
    <div class="about-area2 pb-bottom">
    <div id="website" class="container">
    <div class="row align-items-center">
    <div class="col-xl-6 col-lg-5 col-md-9">
    
    <div class="about-img ">
    <img src="assets/img/guru.png" alt="aplikasi guru sekolah staf pengajar"/>
    </div>
    </div>
    <div class="col-xl-5 col-lg-6 col-md-12">
    <div class="about-caption mb-50">
    <div class="section-tittle mb-25">
    <h2>Guru Apps.</h2>
    </div>
    <p class="mb-20">
Aplikasi guru dengan kemudahan dalam menjalankan tugas nya dengan bantuan <a href="https://axcoraschool.vercel.app" class="text-dark">aplikasi sekolah</a> ini , tersedia fitur jadwal pelajaran , tugas ujian , upload soal dan materi ujian tugas , penerapan nilai , hasil dari tugas dan ujian , absensi kesiswaan per kelas, daftar murid siswa , daftar guru , agenda sekolah , cek website sekolah dan log out keluar dari aplikasi. 
    </p>
    <a href="https://www.youtube.com/watch?v=KfLljbSdwho" target="_blank" class="btn btn-primary text-white">Informasi</a>
    </div>
    </div>
    </div>
    </div>
    </div>
    
        
    <div class="about-area2 section-padding40 section-bg2" data-background="assets/img/section-bg3.png">
        <div id="aplikasi" class="container">
        <div class="row align-items-center">
        <div class="col-xl-5 col-lg-6 col-md-12">
        <div class="about-caption mb-50">
        <div class="section-tittle mb-25">
        <h2>Siswa Apps.</h2>
        </div>
        <p class="mb-20">
  Area khusus untuk siswa murid dalam login web app sekolah ini dengan fitur yang memudahkan dalam proses belajar dan kebutuhan cek keuangan hingga absensi , jadwal pelajaran , tugas ujian, download materi dan tugas, hasil ujian ulangan tugas dan rapot penialian , absensi , agenda sekolah , status dan laporan pembayaran ,website sekolah , logout keluar applikasi .
        </p>
        <a href="https://www.youtube.com/watch?v=9X9rebrD4p4" target="_blank" class="btn all-btn text-white">Informasi</a>
        </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-9 col-sm-9">
        
        <div class="about-img ">
        <img class="img-fluid shadow rounded" src="assets/img/siswa.png" alt="aplikasi sekolah terlengkap"/>
        </div>
        </div>
        </div>
        </div>
        </div>
        
        
        <div class="about-area2 pb-bottom">
        <div id="website" class="container">
        <div class="row align-items-center">
        <div class="col-xl-6 col-lg-5 col-md-9">
        
        <div class="about-img ">
        <img src="assets/img/tata usaha.png" alt="aplikasi guru sekolah staf pengajar"/>
        </div>
        </div>
        <div class="col-xl-5 col-lg-6 col-md-12">
        <div class="about-caption mb-50">
        <div class="section-tittle mb-25">
        <h2>Tata Usaha / Keuangan.</h2>
        </div>
        <p class="mb-20">
Khusus untuk bagian tata usaha dan keuangan untuk mempermudah pembayaran dan cek laporan keuangan sekolah dengan fitur : membuat akun keuangan , menetapkan anggaran nilai akun , melakukan pembayaran dan menerbitkan invoice , cek laporan keuangan detail sekolah. 
        </p>
        </div>
        </div>
        </div>
        </div>
        </div>
    
    <div class="video-area section-bg2 d-flex align-items-center" style="background-image: url('assets/img/aplikasi sekolah e-slearn online.jpg');
              background-repeat: no-repeat;
                background-attachment: fixed;
      background-position: center; 
       background-size: cover;
            "
            >
    <div id="erp" class="container">
    <div class="video-wrap position-relative">
    
    
    <div class="video-icon">
    <a class="popup-video btn-icon" href="https://www.youtube.com/watch?v=rASOvkTJvjI" target="blank">
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-play-fill" viewBox="0 0 16 16">
            <path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
          </svg>
    </a>
    </div>
    </div>
    </div>
    </div>
    
    <div class="slider-area "
    style="background-image: url('assets/img/h1_hero.png');
          background-repeat: no-repeat;
            background-attachment: fixed;
  background-position: center; 
   background-size: cover;
        "
        >
<div class="container">
<div class="row justify-content-center">
    <div class="col-12 col-md-12 p-3 p-md-5">
        <div class="p-3 p-md-5">
    <p class="text-white text-center">
Pricing applikasi sekolah ERP axcora school apps.
    </p>
</div>
</div>

    <div class="col-6 col-md-3 p-3 text-center">
        <div class="shadow rounded bg-white p-3 p-md-3">
            <div class="card-top bg-secondary text-white rounded text-center p-3">
            <span>Basic</span>
            <h4 class="text-white"><strong>Rp.2.642.400</strong></h4>
            <span>per tahun</span>
        </div>
        <div class="p-3">
            <ul>
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> Domain sch.id + Hosting</li>
                    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                        </svg> 1 Landing Page Website</li>    
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> Axcora School ERP Apps</li>
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> 1.8 GB Web Space</li>
               <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> Cloudflare LetsEncrypt</li>
                    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                        </svg> Litespeed web server</li>
                     <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> Layanan support</li>
                 </ul>
                <br/>
                <a href="https://wa.me/6285646104747?text=Axcoraschoolapps%20saya%20mau%20order%20WebsApp%0ANama/Sekolah%20%3A%0AAlamat%20%3A%0APaketweb%20%3Aaxcoraschoolerpbasic%0APrice%20%3ARp.2.642.400/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0A%0Atolong%20diproses%20pesanan%20saya" class="btn card-btn1">Start</a>
            </div>
        </div>
        </div>
        <div class="col-6 col-md-3 p-3 text-center">
            <div class="shadow rounded bg-white p-3 p-md-3">
                <div class="card-top bg-primary text-white rounded text-center p-3">
                <span>Standard</span>
                <h4 class="text-white"><strong>Rp.3.672.800</strong></h4>
                <span>per tahun</span>
            </div>
            <div class="p-3">
                <ul>
                    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                        </svg> Domain sch.id + Hosting</li>
                        <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                            </svg> 1 Landing Page Website</li>    
                            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                                </svg> 1 CMS Website</li>    
                    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                        </svg> Axcora School ERP Apps</li>
                    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                        </svg> 8 GB Web Space</li>
                   <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                        </svg> Cloudflare LetsEncrypt</li>
                        <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                            </svg> Litespeed web server</li>
                         <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                        </svg> Layanan support</li>
                     </ul>
                    <br/>
                    <a href="https://wa.me/6285646104747?text=Axcoraschoolapps%20saya%20mau%20order%20WebsApp%0ANama/Sekolah%20%3A%0AAlamat%20%3A%0APaketweb%20%3Aaxcoraschoolerpstandard%0APrice%20%3ARp.3.672.800/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0A%0Atolong%20diproses%20pesanan%20saya" class="btn card-btn1">Start</a>
               </div>
            </div>
            </div>
            <div class="col-6 col-md-3 p-3 text-center">
                <div class="shadow rounded bg-white p-3 p-md-3">
                    <div class="card-top bg-danger text-white rounded text-center p-3">
                    <span>Premium</span>
                    <h4 class="text-white"><strong>Rp.5.812.600</strong></h4>
                    <span>per tahun</span>
                </div>
                <div class="p-3">
                    <ul>
                        <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                            </svg> Domain sch.id + Hosting</li>
                            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                                </svg> 1 Landing Page Website</li>    
                                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                                    </svg> 1 CMS Website</li>    
                        <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                            </svg> Axcora School ERP Apps</li>
                        <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                            </svg> 24 GB Web Space</li>
                       <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                            </svg> Cloudflare LetsEncrypt</li>
                            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                                </svg> Litespeed web server</li>
                             <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                            </svg> Layanan support</li>
                         </ul>
                        <br/>
                        <a href="https://wa.me/6285646104747?text=Axcoraschoolapps%20saya%20mau%20order%20WebsApp%0ANama/Sekolah%20%3A%0AAlamat%20%3A%0APaketweb%20%3Aaxcoraschoolerppremium%0APrice%20%3ARp.5.812.600/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0A%0Atolong%20diproses%20pesanan%20saya" class="btn card-btn1">Start</a>
                                   </div>
                </div>
                </div>
                
<div class="col-6 col-md-3 p-3 text-center">
    <div class="shadow rounded bg-white p-3 p-md-3">
        <div class="card-top bg-dark text-white rounded text-center p-3">
        <span>Freedom</span>
        <h4 class="text-white"><strong>Rp.25.350</strong></h4>
        <span>per user / bulan</span>
    </div>
    <div class="p-3">
        <ul>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                </svg> Axcora School ERP Apps</li>
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> 10 User minimum</li>    
           <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                </svg> Cloudflare LetsEncrypt</li>
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> Litespeed web server</li>
                 <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                </svg> Layanan support</li>
             </ul>
            <br/>
            <a href="https://wa.me/6285646104747?text=Axcoraschoolapps%20saya%20mau%20order%20WebsApp%0ANama/Sekolah%20%3A%0AAlamat%20%3A%0APaketweb%20%3Aaxcoraschoolerpfreedom%0APrice%20%3ARp.25.000/user/bulan%0AMinimum%2010%20user%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0A%0Atolong%20diproses%20pesanan%20saya" class="btn card-btn1">Start</a>
         </div>
    </div>
    </div>
<div class="col-12 col-md-12 p-3 p-md-5 text-center">
    <img class="img-fluid" src="assets/img/aplikasiedukasi.png" alt="aplikasi sekolah ERP Axcora school"/>
    <div class="p-3 p-md-5 text-center">
<p class="text-white">Mulai gunakan applikasi axcora school ini untuk kemajuan metode dalam dunia pendidikan belajar mengajar hingga handle untuk kebutuhan keuangan sekolah secara detail, saat nya revolusi digital sekolah dimulai bersama axcora technology.</p>
        </div>
</div>
</div>
</div>
</div>

    
    <div class="testimonial-area fix" >

    
    
        <div class="wantToWork-area ">
        <div class="container">
        <div class="wants-wrapper w-padding2 section-bg2" 
         style="background-image: url('assets/img/section_bg02.png');
                  background-repeat: no-repeat;
                    background-attachment: fixed;
          background-position: center; 
           background-size: cover;
                "
                >
        <div class="row align-items-center justify-content-center">
        <div class="col-xl-7 col-lg-9 col-md-8">
        <div class="wantToWork-caption text-center">
        <h2>Website Sekolah</h2>
        <p>Bangun project pembuatan website sekolah anda bersama kami, dengan technology modern struktur dan tatanan yang rapi akan memberikan informasi secara detail mengenai sekolah anda, berbagai technology modern kami gunakan dalam kebutuhan develope project website sekolah agar hasil maksimal dalam skema web app sekolah .
        </p>
        <a routerLink="/website" class="btn3 wantToWork-btn">Pelajari Website Sekolah</a><br/><br/><br/><br/>
        </div>
        </div>
        </div>
        </div>
        </div>
        </div>
        
      </div>
    
